var _ellipse, _rect, _path, _path2, _path3, _path4, _rect2, _rect3, _circle, _rect4, _circle2, _rect5, _rect6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfringe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 28,
    viewBox: "0 0 40 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14,
    cy: 14,
    rx: 14,
    ry: 14,
    fill: "#99CCFF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 5.5,
    width: 28,
    height: 20,
    rx: 1.5,
    fill: "white",
    stroke: "#333333"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 4C9.5 3.17157 10.1716 2.5 11 2.5H18.5C19.0523 2.5 19.5 2.94772 19.5 3.5C19.5 4.60457 20.3954 5.5 21.5 5.5C22.0523 5.5 22.5 5.94772 22.5 6.5V8.5H9.5V4Z",
    fill: "#1B3D81",
    stroke: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 7C10 6.44772 10.4477 6 11 6H36C36.5523 6 37 6.44772 37 7V9H10V7Z",
    fill: "#1B3D81"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6777 14C21.6777 19.2467 17.4244 23.5 12.1777 23.5C6.93103 23.5 2.67773 19.2467 2.67773 14C2.67773 8.75329 6.93103 4.5 12.1777 4.5C17.4244 4.5 21.6777 8.75329 21.6777 14Z",
    fill: "#333333",
    stroke: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.71973 20.5H11.3232V10.7969H7.71973V20.5ZM9.52148 10.2607C10.541 10.2607 11.3145 9.52246 11.3145 8.55566C11.3145 7.58887 10.541 6.85059 9.52148 6.85059C8.50195 6.85059 7.72852 7.58887 7.72852 8.55566C7.72852 9.52246 8.50195 10.2607 9.52148 10.2607ZM12.6768 20.5H16.2803V10.7969H12.6768V20.5ZM14.4785 10.2607C15.498 10.2607 16.2715 9.52246 16.2715 8.55566C16.2715 7.58887 15.498 6.85059 14.4785 6.85059C13.459 6.85059 12.6855 7.58887 12.6855 8.55566C12.6855 9.52246 13.459 10.2607 14.4785 10.2607Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 29.5,
    y: 11.5,
    width: 5,
    height: 7,
    rx: 1.5,
    fill: "white",
    stroke: "#333333"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 14.5,
    width: 11,
    height: 11,
    rx: 1.5,
    fill: "white",
    stroke: "#333333"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 19,
    r: 2,
    fill: "#333333"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 20,
    width: 2,
    height: 3,
    fill: "#333333"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 3,
    r: 1,
    fill: "#1B3D81"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 2.5,
    width: 4,
    height: 1,
    rx: 0.5,
    fill: "#1B3D81"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 29.5,
    y: 2.5,
    width: 1,
    height: 1,
    rx: 0.5,
    fill: "#1B3D81"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfringe);
export default __webpack_public_path__ + "static/media/Infringe.ba71d86773a8b0e6e9a486cbb522c11f.svg";
export { ForwardRef as ReactComponent };